module.exports = __webpack_public_path__ + "img/logo-dupont-vert.4228b735.svg";